module.exports = __webpack_public_path__ + "static/media/fight-begin.e6dfff77.mp3";